import { render } from "./province-attachment.vue?vue&type=template&id=dbf3956a"
import script from "./province-attachment.vue?vue&type=script&lang=js"
export * from "./province-attachment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__